import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "./Paginas/dashboard";
import Usuario from "./Paginas/usuarios";
import Producto from "./Paginas/productos";
import Reportes from "./Paginas/reportes";
import { RouterLayout } from "./Componentes/RouterLayout";
import Login from "./Paginas/login";
import { useState } from "react";
import Impresion from "./Paginas/impresion";
import Opciones from "./Paginas/opciones"
import Inventarios from "./Paginas/Inventario";
import Traspasos from "./Paginas/traspasos";


export const AppRutas = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    return (
        <Routes>
            <Route path="/" element={<RouterLayout />}>
                <Route
                    path="/"
                    element={isLoggedIn ? <Dashboard /> : <Navigate to="/login" />}
                />
                <Route path="/Usuarios" element={<Usuario />} />
                <Route path="/Productos" element={<Producto />} />
                <Route path="/Reportes" element={<Reportes />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/impresion" element={<Impresion />} />
                <Route path="/inventarios" element={<Inventarios />} />
                <Route path="/opciones" element={<Opciones />} />
                <Route path="/traspasos" element={<Traspasos />} />
            </Route>
            <Route
                path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />}
            />
        </Routes>
    );
};